import { Box, ClickAwayListener, Paper, Popper } from '@mui/material';
import { useRef, useState } from 'react';

export const HeaderTooltip = ({ content, children }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  return (
    <>
      <Box
        component="span"
        ref={anchorRef}
        sx={{ display: 'inline-flex', alignItems: 'center' }}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        {children}
      </Box>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        disablePortal={false}
        modifiers={[
          { name: 'offset', options: { offset: [20, 6] } },
          { name: 'preventOverflow', options: { padding: 8 } },
        ]}
        sx={{ zIndex: 20000 }}
      >
        <ClickAwayListener
          onClickAway={() => setOpen(false)}
          disableReactTree
          mouseEvent="onMouseDown"
          touchEvent="onTouchStart"
        >
          <Paper
            elevation={3}
            sx={{ p: 1.5, minWidth: 200, maxWidth: 360 }}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            {content}
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};